import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ExportDocumentsService {

  selectedDocs:string[] = [];
  _selectedDocs = new BehaviorSubject<string[]>([]);
  readonly selectedDocs$ = this._selectedDocs.asObservable();

  addDocument(documentId:string){

     if(this.containsDocument(documentId)){
       return;
     }

    this.selectedDocs.push(documentId);
    this._selectedDocs.next(this.selectedDocs);
  }

  addDocuments(documentIds:string[]){

    documentIds.forEach( d => {
      if(!this.containsDocument(d)){
        this.selectedDocs.push(d);
      }
    });
   
   this._selectedDocs.next(this.selectedDocs);
 }

  removeDocument(documentId:string){
    const index = this.selectedDocs.indexOf(documentId, 0);
    
    if(index >= 0){
      this.selectedDocs.splice(index,1);
    this._selectedDocs.next(this.selectedDocs);
    }
  }

  removeAllDocuments(){
    this.selectedDocs = [];
    this._selectedDocs.next(this.selectedDocs);
  }

  removeDocuments(documentIds:string[]){

    documentIds.forEach( d => {
      const index = this.selectedDocs.indexOf(d, 0);
      if(index >= 0){
        this.selectedDocs.splice(index,1);
      }
    });
   
   this._selectedDocs.next(this.selectedDocs);
 }

  containsDocument(documentId){
    return this.selectedDocs.filter(e => e === documentId).length > 0;
  }
}
